import { checkScreenSize } from '@/common/helpers/screen-size.helper';
import { StepScrollService } from '@/common/step-scroll/step-scroll.service';
import { CheckLoginUseCase } from '@/core/domain/auth/usecases/check-login.usecase';
import { CardDesign } from '@/core/domain/configurations/models/configurations.model';
import { GtmCheckOut } from '@/core/domain/gtm/models/gtm-check-out.models';
import { GtmPageView } from '@/core/domain/gtm/models/gtm-page-view.models';
import { SetDataLayerParamsUseCase } from '@/core/domain/gtm/usecases/setDataLayer.usecase';
import { SavePurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/save-purchase-persistence.usecase';
import { selectAuthValue } from '@/data/auth/store/auth.selectors';
import { setProgressAction } from '@/data/current-progress/store/current-progress.actions';
import { PROGRESS_NAME } from '@/ui/shared/ui/vg-progress/vg-progress.component';
import {
    AfterContentChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, switchMap } from 'rxjs';

@Component({
    selector: 'vg-design',
    templateUrl: './design.component.html',
    styleUrls: ['./design.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DesignComponent implements AfterViewInit, AfterContentChecked {
    public currentImage = '';

    public isUserLogged = false;

    private isMobileOrTablet?: boolean;

    protected selectedCard: CardDesign | undefined = undefined;

    constructor(
        private readonly store: Store<{ currentProgress: PROGRESS_NAME }>,
        private readonly gtmDataLayer: SetDataLayerParamsUseCase,
        private readonly router: Router,
        private readonly savePurchasePersistence: SavePurchaseUseCase,
        private readonly cdref: ChangeDetectorRef,
        private readonly authCheckLogin: CheckLoginUseCase,
        private readonly stepScrollService: StepScrollService,
    ) {
        this.store.dispatch(setProgressAction({ value: 'design' }));
    }
    ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }
    ngAfterViewInit(): void {
        const prevButton = document.querySelector(
            '.swiper-button-prev-outside',
        );
        const nextButton = document.querySelector(
            '.swiper-button-next-outside',
        );

        prevButton?.addEventListener('click', () => {
            // this.changeImageSwipper();
        });

        nextButton?.addEventListener('click', () => {
            // this.changeImageSwipper();
        });

        this.store.select(selectAuthValue).subscribe(() => {
            this.initCheckLogin();
        });

        this.gtmPageView();

        this.isMobileOrTablet = checkScreenSize();
    }

    private initCheckLogin() {
        this.authCheckLogin
            .execute()
            .pipe(
                switchMap((auth) => {
                    if (auth) {
                        this.isUserLogged = auth.isLogged;
                    }
                    return of(null);
                }),
            )
            .subscribe();
    }

    public onImgChange(img: string): void {
        this.currentImage = img;
        this.cdref.detectChanges();
    }

    public onSelectedCard(cardDesign: CardDesign): void {
        this.selectedCard = cardDesign;
        this.cdref.detectChanges();
    }

    public onClickNext(): void {
        this.savePurchasePersistence
            .execute({ cardDesign: this.selectedCard })
            .subscribe();
    }

    public onClickNextAndNextStep(formattedUrl: string): void {
        this.onClickNext();

        this.stepScrollService.nextStep(
            formattedUrl,
            'scroll',
            this.isMobileOrTablet,
        );
    }

    changeImageSwipper() {
        const currentImgSwipper = document.querySelector<HTMLImageElement>(
            '.swiper-slide-active img',
        );
        const currentImg = document.querySelector<HTMLImageElement>(
            '.container-card-price img',
        );

        if (currentImgSwipper && currentImg) {
            currentImg.style.opacity = '0.5';

            setTimeout(function () {
                if (currentImgSwipper && currentImg) {
                    currentImg.src = currentImgSwipper.src;
                }
            }, 400);

            setTimeout(function () {
                if (currentImgSwipper && currentImg) {
                    currentImg.style.opacity = '1';
                }
            }, 600);
        }
    }

    gtmPageView() {
        this.gtmDataLayer.execute<GtmPageView>({
            event: 'ev_pageview',
            page_path: this.router.url,
            page_title: 'design',
        });
        this.gtmDataLayer.execute<GtmCheckOut>({
            event: 'checkout',
            category: 'viva_gift',
            action: 'checkout',
            label: 'choose_design',
            login: this.isUserLogged ? 'Yes' : 'No',
            checkout: { step: '1', step_name: 'choose_design' },
        });
    }
}
